
export const ID_SIDEBAR = 'sidebar';
export const ID_LIVESTREAM = 'livestream';
export const ID_MOBILE_CONTENT = 'mobile-content';

const GLOBAL_RENDERER_ID_SET = new Set<string>([
]);

export const isRendererIdGlobal = (id: string) => GLOBAL_RENDERER_ID_SET.has(id);
